var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddMeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 767.45669,
    height: 518.9454,
    viewBox: "0 0 767.45669 518.9454",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "diet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.09055,
    cy: 509.73343,
    rx: 122.36614,
    ry: 9.21197,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.90931,333.45441c.03921-9.376-7.94859-17.04521-17.32464-17.04521h-87.0032c-9.22781,0-17.20059,7.54238-17.30863,16.76955a16.93583,16.93583,0,0,0,6.57038,13.61051,3.78857,3.78857,0,0,1,1.5005,3.46787,16.85347,16.85347,0,0,0-.15147,2.25584v60.17963a16.86805,16.86805,0,0,0,16.86805,16.86806h71.49478a16.868,16.868,0,0,0,16.868-16.868V352.513a16.95686,16.95686,0,0,0-.11521-1.97565,3.65945,3.65945,0,0,1,1.53937-3.37824A16.94627,16.94627,0,0,0,340.90931,333.45441Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.14153,331.80343a13.49549,13.49549,0,0,0-13.50466-11.71681H236.55552a13.528,13.528,0,0,0-13.30095,10.4778,13.31676,13.31676,0,0,0,6.36476,14.342,3.66255,3.66255,0,0,1,1.71427,4.147,13.0587,13.0587,0,0,0-.46393,3.46243v60.17393a13.198,13.198,0,0,0,10.74939,12.96715,13.35794,13.35794,0,0,0,2.44407.22631h71.49474a13.04609,13.04609,0,0,0,3.56993-.4922,13.19106,13.19106,0,0,0,9.61787-12.6956V352.51017a13.13232,13.13232,0,0,0-.40732-3.24745,3.76774,3.76774,0,0,1-.11316-.89956,3.66833,3.66833,0,0,1,1.9462-3.23612l.00567-.00566A13.28987,13.28987,0,0,0,337.14153,331.80343Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#7722ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.74567,358.27523v-5.65757H319.1278v-32.531h-5.65757v32.531h-30.268v-32.531h-5.65758v32.531h-30.268v-32.531h-5.65757v32.531H230.86967v5.65757h10.74939V375.248H230.86967v5.65757h10.74939v16.97272H230.86967v5.65757h10.74939v22.1211a13.35794,13.35794,0,0,0,2.44407.22631h3.2135V403.53581h30.268v22.34741h5.65758V403.53581h30.268v22.34741h2.08764a13.04609,13.04609,0,0,0,3.56993-.4922V403.53581h9.61787v-5.65757H319.1278V380.90552h9.61787V375.248H319.1278V358.27523Zm-81.469,0h30.268V375.248h-30.268Zm0,39.603V380.90552h30.268v16.97272Zm66.1936,0h-30.268V380.90552h30.268Zm0-22.63029h-30.268V358.27523h30.268Z",
    transform: "translate(-216.27165 -190.5273)",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M340.51292,190.5273a60.42237,60.42237,0,1,1-120.84474,0H340.51292Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#7722ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.835,201.25317c0,1.57966-.56025,2.86023-1.25136,2.86023s-1.25135-1.28057-1.25135-2.86023a4.66151,4.66151,0,0,1,1.25135-2.86024A4.66149,4.66149,0,0,1,241.835,201.25317Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M305.11757,211.264c0,1.57966-.56025,2.86023-1.25135,2.86023s-1.25135-1.28057-1.25135-2.86023a4.6615,4.6615,0,0,1,1.25135-2.86023A4.6615,4.6615,0,0,1,305.11757,211.264Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.63882,205.54351c0,1.57966-.56025,2.86023-1.25135,2.86023s-1.25135-1.28057-1.25135-2.86023a4.6615,4.6615,0,0,1,1.25135-2.86023A4.6615,4.6615,0,0,1,258.63882,205.54351Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M283.66584,228.06783c0,1.57966-.56025,2.86023-1.25135,2.86023s-1.25135-1.28057-1.25135-2.86023a4.6615,4.6615,0,0,1,1.25135-2.86023A4.6615,4.6615,0,0,1,283.66584,228.06783Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256.85118,225.2076c0,1.57966-.56025,2.86023-1.25135,2.86023s-1.25136-1.28057-1.25136-2.86023a4.66148,4.66148,0,0,1,1.25136-2.86023A4.6615,4.6615,0,0,1,256.85118,225.2076Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M319.41872,198.39293c0,1.57967-.56025,2.86024-1.25135,2.86024s-1.25135-1.28057-1.25135-2.86024a4.6615,4.6615,0,0,1,1.25135-2.86023A4.6615,4.6615,0,0,1,319.41872,198.39293Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M296.53688,233.78829c0,1.57966-.56025,2.86023-1.25135,2.86023s-1.25135-1.28057-1.25135-2.86023a4.6615,4.6615,0,0,1,1.25135-2.86023A4.6615,4.6615,0,0,1,296.53688,233.78829Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.09055,254.3462a63.89126,63.89126,0,0,1-63.8189-63.8189h6.793a57.02585,57.02585,0,1,0,114.0517,0h6.793A63.89126,63.89126,0,0,1,280.09055,254.3462Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190.8189,
    y: 21.90945,
    width: 20,
    height: 20,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 245.8189,
    y: 30.90945,
    width: 161,
    height: 2,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 190.8189,
    y: 172.45762,
    width: 20,
    height: 20,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 245.8189,
    y: 181.45762,
    width: 161,
    height: 2,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 190.8189,
    y: 321.95928,
    width: 20,
    height: 20,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 245.8189,
    y: 330.95928,
    width: 161,
    height: 2,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M848.5961,327.8717,823.048,348.00889,768.91259,328.983s-18.4063-20.70326-28.81476-5.2831c-3.56469,5.28109,19.78367,15.03777,21.98638,15.94449,5.50677,2.2668,58.25833,31.20711,63.42758,27.41029S859.76524,344.054,859.76524,344.054Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M935.80607,293.52018c-24.21353-9.04778-47.2472-13.32858-65.92215,0v-43.017a32.961,32.961,0,0,1,32.961-32.961h.00007a32.961,32.961,0,0,1,32.961,32.96105Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M874.9647,387.49148l-1.97859,13.85007s-4.94645,14.83936,0,42.5395l-79.6379,217.1493L852.211,677.8483l29.18407-118.71489,41.05557-90.52009-3.95716,102.88623L897.71838,681.31081l61.336-2.47322,17.87333-188.29338a166.79258,166.79258,0,0,0-14.94512-86.82478c-4.95829-10.53-10.28946-18.82906-15.12686-20.0337C932.34355,380.0718,874.9647,387.49148,874.9647,387.49148Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M800.76789,659.54642l-20.28045,21.76439s-39.077,20.28046-11.37685,22.75369,37.0984-8.409,37.0984-8.409,34.62518-2.47323,34.13053-7.41968-2.96787-21.26975-2.96787-21.26975Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M910.82648,664.7943v15.334s.49465,6.43039,0,7.91432-7.91432,19.78582,16.81794,15.82865,14.83936-19.29116,14.83936-19.29116l-5.93574-22.259Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 686.26952,
    cy: 65.26486,
    r: 24.85593,
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M919.7301,269.51857s-3.46252,32.64659,0,38.58233-35.11982-5.93574-35.11982-5.93574,8.409-22.259,5.4411-31.16266S919.7301,269.51857,919.7301,269.51857Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#a0616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M939.51591,363.50118l7.91433,21.7644-73.70216,8.409s-7.91432-1.48394-7.91432-7.91433-8.409-29.18407-8.409-29.18407-20.5947-16.69242-30.48761-21.14423c-3.58618-1.61255,1.77837-.94665,4.79576-7.79252.90524-2.05775,1.98848-4.22922,3.17063-6.43039.96453-1.80547,2.00334-3.63566,3.06678-5.4411,1.29107-2.20118,2.62164-4.36773,3.91272-6.43039,3.90765-6.23747,7.474-11.48073,8.61668-13.60275,3.46252-6.43039,36.01516-7.00419,36.01516-7.00419,9.30914,5.85661,36.20306,7.00419,36.20306,7.00419s18.49969,7.74118,26.2063,13.60275C949.46316,309.758,939.51591,363.50118,939.51591,363.50118Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M923.5155,225.95361v-.59023l-.70153.039a32.98613,32.98613,0,0,0-28.34891-5.66484,32.84353,32.84353,0,0,1,12.65187,6.53687L883.29181,227.598l-10.05592,22.34649h6.80549l5.48508-10.05592v10.05592h23.01686l1.56428-7.82127,4.34519,7.82127H918.975c.028.55764.07119,1.11132.07119,1.67592l-4.4693,43.01707,21.22917-8.9386V251.62044A32.89189,32.89189,0,0,0,923.5155,225.95361Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M956.8285,339.75821l-1.48394,39.077-3.95716,75.68074s5.4411,32.64659-8.409,32.15194-3.46252-38.58233-3.46252-38.58233l-3.95716-59.85209,3.95716-42.04485Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#a0616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M960.78566,361.028c0,4.4518-24.97959,3.21519-24.97959,3.21519L922.698,295.73477s18.49969,7.74118,26.2063,13.60275a23.23,23.23,0,0,1,4.38756,6.43039c.5886,1.58779,1.14749,3.42789,1.6768,5.4411.52435,1.99835,1.014,4.16985,1.474,6.43039A263.16223,263.16223,0,0,1,960.78566,361.028Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M279.41779,519.9509l-37.86207-3.92015a12.01987,12.01987,0,1,0-20.69612,6.466,12.02549,12.02549,0,1,0,20.56292,5.55936l37.99527-3.49266Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M317.91955,545.97346c14.88426,3.66007,29.87864-6.89711,30.6546-22.20512q.03228-.6368.03241-1.28176t-.03241-1.28176c-.776-15.308-15.77034-25.86518-30.6546-22.20512l-50.49448,12.41668a11.07021,11.07021,0,1,0,0,22.14041Z",
    transform: "translate(-216.27165 -190.5273)",
    fill: "#7722ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMeal);
export default __webpack_public_path__ + "static/media/addMeal.923cde9326a9407b4e9594a05ec9c342.svg";
export { ForwardRef as ReactComponent };